<main>
  <div class="row profile-wizard condensed" [ngClass]="{'fly-out': isFlyout}">
    <div class="col center">
      <h1>Get the most out of Rankipedia! <span class="block bold">Setup your profile</span></h1>
      <div class="progress-tracker">
        <!-- <div class="progress">
        <span class="bar" style="width: 550px;"></span>
      </div>
      <span class="progress-completed">100% completed</span>
      <div *ngIf="profileService.submitedStep[0]">
        <a href="/">Skip and go to your profile</a>
      </div> -->
      </div>
      <div class="row wizard-steps">
        <div class="col steps">
          <ul>
            <li class="complete current">
              <a (click)="onStepChange($event)">Organization overview</a>
            </li>
            <li *ngIf="profileService.submitedStep[0]">
              <a (click)="onStepChange2($event)">Organization Details</a>
            </li>
            <li *ngIf="profileService.submitedStep[0]">
              <a (click)="onStepChange2($event)">Products and Services</a>
            </li>
            <li *ngIf="profileService.submitedStep[0]">
              <a (click)="onStepChange2($event)">Portfolio</a>
            </li>
            <li *ngIf="profileService.submitedStep[0]">
              <a (click)="onStepChange2($event)">Education</a>
            </li>
          </ul>
          <!-- Current step indicator -->
          <span class="indicator" style="top: 87.5px;"></span>
        </div>
        <div class="col wizard">
          <div *ngIf="curStep1">
            <app-profile1></app-profile1>
          </div>
        </div>
      </div>
    </div>
    <a onclick="parent.callbackParent();" style="display:none;" id="btnCallback" href="javascript:void(0);"></a>
  </div>
</main>
